import { AnserJsonEntry } from "anser";
import { useCallback } from "react";

import { Copy } from "components/icons/generated";
import { RunContext } from "components/Run/Context";
import Button from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";
import useAnalytics from "hooks/useAnalytics";
import useLazyCopyToClipboard from "hooks/useLazyCopyToClipboard";
import useTypedContext from "hooks/useTypedContext";
import { RunState } from "types/generated";

type RunCopyLogsButtonProps = {
  decoded: AnserJsonEntry[];
  expired: boolean;
  disabled?: boolean;
  state: RunState;
  isFullscreen: boolean;
};

const RunCopyLogsButton = ({
  decoded,
  expired,
  disabled,
  state,
  isFullscreen,
}: RunCopyLogsButtonProps) => {
  const {
    run: { state: runState },
  } = useTypedContext(RunContext);
  const trackSegmentAnalyticsEvent = useAnalytics();
  const copyToClipboard = useLazyCopyToClipboard();

  const handleCopy = useCallback(async () => {
    const copied = await copyToClipboard(decoded.map(({ content }) => content).join(""));

    if (copied) {
      trackSegmentAnalyticsEvent("Run Logs - copy logs", {
        isFullscreen,
        logsState: state,
        runState,
        via: "button",
      });
    }
  }, [copyToClipboard, decoded, trackSegmentAnalyticsEvent, isFullscreen, state, runState]);

  return (
    <Tooltip
      active={expired}
      on={(props) => (
        <Button
          {...props}
          variant="secondary"
          startIcon={Copy}
          size="small"
          onPress={handleCopy}
          disabled={disabled || expired}
        >
          Copy
        </Button>
      )}
    >
      These logs have expired.
    </Tooltip>
  );
};

export default RunCopyLogsButton;
